
import React, { useState } from "react";
import { MainLayout } from "@/components/layout/MainLayout";
import OnboardingWelcome from "./OnboardingWelcome";
import OnboardingWizardContainer from "./OnboardingWizardContainer";

const OnboardingPage = () => {
  const [wizardOpen, setWizardOpen] = useState(true);

  return (
    <MainLayout>
      <OnboardingWelcome onStart={() => setWizardOpen(true)} />
      <OnboardingWizardContainer open={wizardOpen} onClose={() => setWizardOpen(false)} />
    </MainLayout>
  );
};

export default OnboardingPage;
